export interface CreateNewFoundationInput {
  foundationName: string;
}
